import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";

const BASE_URL = process.env.REACT_APP_API_URL;

const FormularioPublicaciones = () => {
  const [titulo, setTitulo] = useState("");
  const [contenido, setContenido] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!titulo || !contenido) {
      alert("Por favor, complete todos los campos.");
      return;
    }

    publicarAnuncio({ titulo, contenido });
    setTitulo("");
    setContenido("");
  };
  const publicarAnuncio = async ({ titulo, contenido }) => {
    const now = new Date();
    const fechaHora = now.toISOString().split('T').join(' ').split('Z')[0]; 
    try {
      const response = await fetch(`${BASE_URL}/publicaciones`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('token')}`      
        },
        body: JSON.stringify({
          FechaPublicacion: fechaHora,
          Visibilidad: "publico",
          FechaEnvio: fechaHora,
          Titulo: titulo,
          Texto: contenido
      }),
      });
      if (!response.ok) {
        throw new Error(`Error al publicar: ${response.statusText}`);
      }
  
      const data = await response.json();
      alert("Anuncio publicado con éxito.");
      console.log("Respuesta del servidor:", data);
    } catch (error) {
      console.error("Error al publicar el anuncio:", error);
      alert("Hubo un error al publicar el anuncio. Por favor, intente nuevamente.");
    }
  };
  

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="titulo">
          <Form.Label>Título de la Publicacion</Form.Label>
          <Form.Control
            type="text"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
            placeholder="Escribe el título de la Publicacion..."
          />
        </Form.Group>

        <Form.Group controlId="contenido" className="mt-3">
          <Form.Label>Contenido de la Publicacion</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={contenido}
            onChange={(e) => setContenido(e.target.value)}
            placeholder="Escribe el contenido de la Publicacion..."
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="mt-4">
          Publicar
        </Button>
      </Form>
    </div>
  );
};

export default FormularioPublicaciones;
